import { supabase } from "@/utils/supabase";

const FUNCTIONS_URL = `${process.env.VUE_APP_SUPABASE_URL}/functions/v1`;

export default {
  // 이미지/파일 업로드 → R2(virtupet-cdn) users/{user_id}/{filename}
  //  - file: File | Blob (필수)
  //  - filename: 저장 파일명(옵션, 없으면 file.name). 서브경로 허용("avatar/main.webp"), ".." 차단.
  //  네임스페이스(user_id)는 JWT에서 서버가 결정 → 클라가 보낼 필요 없음.
  //  반환: { key, url }  (url = https://cdn.virtupet.tv/users/{uid}/{filename})
  async upload(file, filename) {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session) throw new Error("E_NOT_LOGGED_IN");
    if (!file) throw new Error("E_NO_FILE");

    const form = new FormData();
    form.append("file", file);
    if (filename) form.append("filename", filename);

    // ⚠️  multipart는 Content-Type 직접 지정 금지 (브라우저가 boundary 자동 설정)
    const res = await fetch(`${FUNCTIONS_URL}/storage/upload`, {
      method: "POST",
      headers: {
        apikey: process.env.VUE_APP_SUPABASE_KEY,
        Authorization: `Bearer ${session.access_token}`,
      },
      body: form,
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw Object.assign(new Error(json.message || "E_UPLOAD_FAILED"), { detail: json, status: res.status });
    }
    return json; // { key, url }
  },
};
